<template>

  <div class="elements-list">
    <!--<v-marker-cluster :options="cluster">-->
      <map-element v-for="(item, index) in elements" :key="index"
                   :element="item"
                   :selected="selected"
                   :locked="locked"
                   @click="$emit('click', { event: $event, element: item })"
                   @menu="$emit('menu', $event)">
      </map-element>
    <!--</v-marker-cluster>-->
  </div>

</template>

<script>

import { mapState, mapGetters } from 'vuex'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import MapElement from './map-element'
import { MapService } from '../services/map.service.es6'

export default {
  name: 'map-elements-list',

  props: [ 'elements' ],

  data () {
    return {
      cluster: {
        maxClusterRadius: 30,
        disableClusteringAtZoom: 15
      }
    }
  },

  computed: {
    ...mapState('map', [
      'selected',
      'locked'
    ]),

    ...mapGetters('map', [
      'alarms'
    ])
  },

  methods: {

  },

  watch: {
    alarms (alarms) {
      const ids = alarms.map(alarm => alarm.assetId)

      this.elements
        .filter(element => ids.indexOf(element.assetId) > -1)
        .forEach(element => MapService.updateElementStatus(element))
    }
  },

  components: {
    MapElement,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  }
}

</script>

<style lang="scss" scoped>

</style>
